import SanitizedHtml from "./SanitizedHtml";

export default SanitizedHtml;
